<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00006 13.36C7.00057 13.2253 7.0283 13.0921 7.08157 12.9684C7.13484 12.8446 7.21256 12.7329 7.31006 12.64L11.3101 8.78C11.497 8.59677 11.7483 8.49414 12.0101 8.49414C12.2718 8.49414 12.5231 8.59677 12.7101 8.78L16.7101 12.78C16.8033 12.8732 16.8773 12.9839 16.9277 13.1057C16.9782 13.2276 17.0042 13.3581 17.0042 13.49C17.0042 13.6219 16.9782 13.7524 16.9277 13.8742C16.8773 13.9961 16.8033 14.1068 16.7101 14.2C16.6168 14.2932 16.5061 14.3672 16.3843 14.4177C16.2625 14.4681 16.1319 14.4941 16.0001 14.4941C15.8682 14.4941 15.7376 14.4681 15.6158 14.4177C15.494 14.3672 15.3833 14.2932 15.2901 14.2L12.0001 10.9L8.70006 14.08C8.5127 14.2663 8.25925 14.3708 7.99506 14.3708C7.73088 14.3708 7.47742 14.2663 7.29006 14.08C7.19617 13.9854 7.12215 13.8729 7.07235 13.7493C7.02255 13.6256 6.99797 13.4933 7.00006 13.36Z"
      :fill="color === undefined ? 'black' : color"
    />
  </svg>
</template>
<script>
export default {
  name: "ArrowUpIcon",
  props: {
    color: String,
  },
};
</script>
